import React from "react";
import StyledDropzone from "components/chooseFile";
import styled, { css } from "styled-components";
import { get, map } from "lodash";
import { Delete } from "assets/icons";
import Button from "components/button";
import Checkbox from "components/checkbox";
import ButtonScrollSlider from "components/buttonScrollSlider";

export default function index(props) {
  const { isActiveOnClickTemplateBlocks } = props;
  const {
    selectedOption,
    handleOptionChange,
    metaDataName,
    handleInputChange,
    metaDataList,
    metaDataError,
    addMetaData,
    removeMetaData,
    handleInputDefaultValueChange,
    metaDataDefaultName,
    handleCheckboxHandler,
    checkboxValue,
    saveHandlerHtmlTemplate,
    uploadFileToRepo,
    fetchCoverImageData,
    htmlTemplateImages
  } = props;

  return (
    <>
      <EncapsulateHtmlCss>
        <HtmlTemplateWrapper>
          <Heading>
            HTML Template:
            <Filename>
              {isActiveOnClickTemplateBlocks.htmlUploadedFileName
                ? get(isActiveOnClickTemplateBlocks, `htmlUploadedFileName`)
                : get(isActiveOnClickTemplateBlocks, `htmlFilename`)}
            </Filename>
          </Heading>
          <StyledDropzone
            {...props}
            uploadFileType="html"
            hint="Drag a HTML file here or click to browse"
          />
        </HtmlTemplateWrapper>

        <CssUploadWrapper>
          <Heading>
            CSS file:
            <Filename>
              {isActiveOnClickTemplateBlocks.cssUploadedFileName
                ? get(isActiveOnClickTemplateBlocks, `cssUploadedFileName`)
                : get(isActiveOnClickTemplateBlocks, `cssFilename`)}
            </Filename>
          </Heading>
          <StyledDropzone
            {...props}
            uploadFileType="css"
            hint="Drag a CSS file here or click to browse"
          />
        </CssUploadWrapper>
      </EncapsulateHtmlCss>

      <ButtonScrollSliderWrapper>
        {get(htmlTemplateImages, `length`) ? (
          <ImageSlider>
            <ButtonScrollSlider
              contentElements={htmlTemplateImages}
              isShowDeleteIcon={true}
            />
          </ImageSlider>
        ) : (
          <ImageSlider>
            <NoContentElement>Your cover images go here.</NoContentElement>
          </ImageSlider>
        )}
      </ButtonScrollSliderWrapper>
      <UploadImageFile>
        <Heading>Image File:</Heading>
        <ChooseFileWrapper>
          <StyledDropzone
            className="upload-file"
            {...props}
            uploadFileToRepo={({ metaDeta, file }, cb) => {
              uploadFileToRepo({ metaDeta, file }, cb, {}, () =>
                fetchCoverImageData()
              );
            }}
            uploadFileType="image"
            hint="Drag a .JPG or .PNG file here or click to browse"
          />
        </ChooseFileWrapper>
      </UploadImageFile>

      <MetaDataWrapper>
        <Heading>Add Metadata:</Heading>
        <BlockHeader>
          <Button
            text="Save"
            width="100px"
            float="none"
            buttonClass="save"
            onClick={saveHandlerHtmlTemplate}
          />
        </BlockHeader>
        <MetaDataForm>
          <FormGroup className="form-group">
            <Input
              value={metaDataName}
              type="text"
              placeholder="Enter Name"
              onChange={handleInputChange}
            />

            <Select value={selectedOption} onChange={handleOptionChange}>
              <Option value="image">Image</Option>
              <Option value="string">String</Option>
              <Option value="date">Date</Option>
              <Option value="type" className="default-selected">
                Type
              </Option>
            </Select>

            <CheckboxWrapper
              type="checkbox"
              name="Required"
              label="Required"
              checked={checkboxValue}
              handleChange={handleCheckboxHandler}
              defaultChecked={false}
            />

            {selectedOption === "string" && (
              <Input
                value={metaDataDefaultName}
                type="text"
                placeholder="Default Value"
                onChange={handleInputDefaultValueChange}
                style={{ marginLeft: "20px" }}
              />
            )}
            {metaDataError && <MetaDataError>{metaDataError}</MetaDataError>}
          </FormGroup>
          <FormControl className="form-control">
            <Button
              text="Add New"
              width={112}
              height={30}
              onClick={addMetaData}
            />
            {/* <Submit onClick={addMetaData}>Add New</Submit> */}
          </FormControl>
        </MetaDataForm>

        {get(metaDataList, `length`) ? (
          <MetaDataList>
            {map(metaDataList, (eachMetaData, index) => {
              return (
                <MetaDataLi>
                  <MetaDataName>{eachMetaData.label}</MetaDataName>
                  <MetaDataType>{eachMetaData.type}</MetaDataType>
                  <input type="checkbox" checked={eachMetaData.required} />
                  Required
                  {eachMetaData.type == "string" ? (
                    <MetaDataDefaultName>
                      {eachMetaData.defaultValue}
                    </MetaDataDefaultName>
                  ) : (
                    <EmptySpaceView />
                  )}
                  <IconWrapper title="Delete">
                    <Delete
                      onClick={() => {
                        removeMetaData(eachMetaData._id, index);
                      }}
                    />
                  </IconWrapper>
                </MetaDataLi>
              );
            })}
          </MetaDataList>
        ) : (
          <></>
        )}
      </MetaDataWrapper>
    </>
  );
}

const HtmlTemplateWrapper = styled.span``;

const CssUploadWrapper = styled.span`
  margin: 0px 20px;
`;

const Filename = styled.span`
  font-size: 14px;
  margin-left: 3px;
`;

const Heading = styled.h3`
  ${props => props.theme.SNIPPETS.FONT_STYLE};
  font-size: 20px;
  font-weight: bold;
  color: ${props => props.theme.COLOR.MAIN};
  margin: 10px 0;
  text-align: left;
`;

const MetaDataWrapper = styled.div``;

const UploadImageFile = styled.div`
  width: 48%;
`;

const UploadPptxFile = styled.div`
  width: 48%;
`;

const MetaDataForm = styled.form`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
`;

const FormGroup = styled.div`
  display: flex;
  position: relative;
  text-align: left;
  align-items: center;
`;

const Input = styled.input`
  width: 160px;
  height: 30px;
  padding: 5px 10px;
  margin: 0 20px 0 0;
  border-style: none;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  ${props => props.theme.SNIPPETS.FONT_STYLE};
  font-size: 15px;
  font-weight: 500;
  color: ${props => props.theme.COLOR.MAIN};
  box-sizing: border-box;
`;

const Select = styled.select`
  width: 90px;
  height: 30px;
  padding: 4px 10px 6px;
  margin: 0 20px 0 0;
  border-style: none;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  ${props => props.theme.SNIPPETS.FONT_STYLE};
  font-size: 15px;
  font-weight: 500;
  color: ${props => props.theme.COLOR.MAIN};
  background-color: transparent;
  box-sizing: border-box;
  transform: translateY(-1px);
`;

const Option = styled.option`
  &.default-selected {
    display: none;
  }
`;

const FormControl = styled.div`
  button {
    height: 30px;
  }
  margin-left: 20px;
`;

const MetaDataList = styled.ul`
  padding: 25px 0 10px;
`;

const MetaDataLi = styled.li`
  padding: 0 0 10px;
  display: flex;
  flex-direction: row;
  text-align: left;
`;

const MetaDataName = styled.span`
  width: 160px;
  height: 30px;
  padding: 5px 10px;
  margin: 0 20px 0 0;
  border-style: none;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  ${props => props.theme.SNIPPETS.FONT_STYLE};
  font-size: 15px;
  font-weight: 500;
  color: ${props => props.theme.COLOR.MAIN};
  background-color: transparent;
  box-sizing: border-box;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const MetaDataType = styled.span`
  width: 90px;
  height: 30px;
  padding: 5px 10px;
  margin: 0 20px 0 0;
  border-style: none;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  ${props => props.theme.SNIPPETS.FONT_STYLE};
  font-size: 15px;
  font-weight: 500;
  color: ${props => props.theme.COLOR.MAIN};
  background-color: transparent;
  box-sizing: border-box;
  display: block;
  text-transform: capitalize;
`;

const MetaDataError = styled.span`
  position: absolute;
  bottom: -17px;
  left: 0;
  font-size: 12px;
  color: red;
`;

const SharedIconWrapperCss = css`
  padding: 0;
  height: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  svg:hover {
    opacity: 0.7;
  }

  svg {
    height: 17px;
    cursor: pointer;
  }
`;

const IconWrapper = styled.span`
  ${SharedIconWrapperCss};
`;

const CheckboxWrapper = styled(Checkbox)`
  display: inline-block;
  margin-right: 10px;
`;

const EmptySpaceView = styled.span`
  width: 160px;
  height: 30px;
  padding: 5px 10px;
  margin: 0 20px 0 0px;
`;

const MetaDataDefaultName = styled.span`
  width: 160px;
  height: 30px;
  padding: 5px 10px;
  margin: 0 20px 0 0;
  border-style: none;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  ${props => props.theme.SNIPPETS.FONT_STYLE};
  font-size: 15px;
  font-weight: 500;
  color: ${props => props.theme.COLOR.MAIN};
  background-color: transparent;
  box-sizing: border-box;
  display: block;
  margin-left: 20px !important;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const BlockHeader = styled.div`
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 20px;
`;

const EncapsulateHtmlCss = styled.div`
  display: flex;
`;

const ChooseFileWrapper = styled.div`
  width: 100%;
  margin: auto;
  .btn-container {
    display: flex;
    flex-wrap: wrap-reverse;
    justify-content: center;
  }
  @media (max-width: 940px) {
    .filename {
      max-width: 117px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  & > div:first-child > div:first-child {
    height: 190px;
  }
`;
const ButtonScrollSliderWrapper = styled.div``;

const ImageSlider = styled.div`
  margin-top: 30px;
`;
const NoContentElement = styled.div`
  min-height: 100px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  ${props => props.theme.SNIPPETS.FONT_STYLE};
  font-size: 13px;
  font-weight: bold;
  color: ${props => props.theme.COLOR.MAIN};
  background-color: rgba(0, 0, 0, 0.05);
`;
